import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const C949 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">
        You're viewing C949 - Data Structures and Algorithms I
      </h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 6.50 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            This course is EASY. I read so many people saying it's hard, but
            just don't overcomplicate it.
          </p>
          <p>
            How I studied for this course:
            <ol>
              <li><a href="/C949 v4 Study Guide.docx" download="C949 v4 Study Guide.docx">Download this guide.</a></li>
              <li>
                Watched ALL of Dr. Youngblood’s cohorts. THEY ARE SO FREAKING
                GOOD. The way he explained sorting and data structures—I swear
                it’s still stuck in my head. You can find them here:
                <br />
                🔗{" "}
                <a
                  href="https://srm--c.vf.force.com/apex/CourseArticle?id=kA03x000000tcVFCAY&groupId=&searchTerm=&courseCode=C949&rtn=%2Fapex%2FCommonsExpandedSearch"
                  target="_blank"
                  rel="noreferrer"
                >
                  Dr.Youngblood’s Cohorts
                </a>
              </li>
              <li>Took the PA and got about 70%.</li>
            </ol>
            The OA was SLIGHTLY more difficult than the PA, but my advice? Don’t
            waste too much time on study material because this is a logical
            course. The answer is almost always hidden in the question. If you
            read carefully and focus, you’ll find it.
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};
export default C949;
